import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';

const WeelodgeInfoContent = ({ label, value, isArray, withContent }) => (
  <div className="wrapper">
    <div className="header">{label}</div>
    {isArray ? (
      value.map((v, index) => <span key={`${v}_${index}`} className="content">{withContent ? v.name : v}</span>)
    ) : (
      <span className="content">{value}</span>
    )}
  </div>
);

WeelodgeInfoContent.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  isArray: PropTypes.bool,
  withContent: PropTypes.bool,
};

WeelodgeInfoContent.defaultProps = {
  isArray: false,
  withContent: false,
};

export default translate(WeelodgeInfoContent);
